import { render, staticRenderFns } from "./ToggleDot.vue?vue&type=template&id=7a1a6e3e&lang=pug&"
import script from "./ToggleDot.vue?vue&type=script&lang=js&"
export * from "./ToggleDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports